export default __webpack_public_path__ + "static/media/home-bg.54ebd199.png";